import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalClose() {
  return <section className="relative bg-sand py-[32px] md:py-[48px] px-6 overflow-hidden" data-id="element-55">
      <div className="relative z-10 max-w-[720px] mx-auto text-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-57">
          <p className="font-mono text-[11px] tracking-[0.12em] text-cocoa uppercase mb-8" data-id="element-58">
            Para el hermano latino que lleva años buscando respuestas
          </p>

          <div className="space-y-5 mb-8" data-id="element-59">
            <p className="font-serif italic text-[20px] leading-[1.8] text-text-primary" data-id="element-60">
              Para el que sale de cada consulta con más preguntas que
              respuestas.
            </p>
            <p className="font-serif italic text-[20px] leading-[1.8] text-text-primary" data-id="element-61">
              Para el que intenta cuidarse pero siente que nadie le dio el mapa
              completo.
            </p>
            <p className="font-serif italic text-[20px] leading-[1.8] text-text-primary" data-id="element-62">
              Para el padre que piensa en sus hijos y se pregunta si ellos van a
              heredar esto.
            </p>
            <p className="font-serif italic text-[20px] leading-[1.8] text-text-primary" data-id="element-63">
              Para la mujer que cuida la salud de toda la familia menos la suya
              propia.
            </p>
            <p className="font-serif italic text-[20px] leading-[1.8] text-text-primary" data-id="element-64">
              Para el adulto mayor de 40 que siente que se está quedando atrás
              en un sistema de salud que habla un idioma que no siempre
              entiende.
            </p>
          </div>

          <div className="flex justify-center mb-8" data-id="element-65">
            <div className="w-[48px] h-[1px] bg-gradient-to-r from-transparent via-soft-gold to-transparent" data-id="element-66"></div>
          </div>

          <p className="font-serif text-[18px] leading-[1.6] text-text-primary mb-8" data-id="element-67">
            Roderic Guillen sobrevivió seis bypass coronarios.
            <br data-id="element-68" />
            No para guardar esa experiencia para sí mismo.
            <br data-id="element-69" />
            Sino para que tú tengas el mapa que a él nadie le dio.
          </p>

          <p className="font-serif italic text-[16px] leading-[1.7] text-text-secondary mb-8 max-w-[600px] mx-auto" data-id="element-70">
            "La información sobre tu propio cuerpo no debería vivir solo en
            revistas académicas en inglés. Te pertenece. Y este libro es parte
            del camino para devolvértela."
          </p>

          <div className="flex flex-col items-center justify-center gap-4" data-id="element-71">
            <div className="w-[80px] h-[80px] rounded-full border border-cocoa flex items-center justify-center bg-ivory shadow-sm" data-id="element-72">
              <span className="font-serif text-cocoa text-[24px]" data-id="element-73">RG</span>
            </div>
            <p className="font-mono text-[12px] text-text-muted" data-id="element-74">
              — Roderic Guillen · Sobreviviente de 6 bypass coronarios ·
              GoDeskCore · Heartbeat
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}